import { 
    LOG_OUT_USER,
    FETCH_MAINTENANCES,
    ADD_MAINTENANCE,
    UPDATE_MAINTENANCE,
    DELETE_MAINTENANCE
 } from "../../actions/actionTypes";

 
const fetchMaintenancesReducer = (maintenances, payload) => {
    // if offset == "" then it means we are refetching data. 
    let newMaintenances = payload.offset == "" ? {} : { ...maintenances };
    for(let maintenance of payload.maintenances){
        newMaintenances[maintenance.maintenanceId] = maintenance;
    }
    return newMaintenances;
}


const addMaintenanceReducer = (maintenances, payload) => {
    let newMaintenances = {
        ...maintenances,
        [payload.maintenance.maintenanceId]: {...payload.maintenance}
    };
    return newMaintenances;
}

const updateMaintenanceReducer = (maintenances, payload) => {
    let newMaintenances = {
        ...maintenances,
        [payload.maintenance.maintenanceId]: {
            ...maintenances[payload.maintenanceId],
            ...payload.maintenance
        }
    };
    return newMaintenances;
}

const deleteMaintenanceReducer = (maintenances, payload) => {
    let newMaintenances = { ...maintenances};
    delete newMaintenances[payload.maintenanceId];
    return newMaintenances;
}



const maintenancesReducer = (state={}, action) => {
    let maintenances = state;
    if (action.errors == null){
        switch(action.type){
            case FETCH_MAINTENANCES:
                return fetchMaintenancesReducer(maintenances, action.payload);
            case ADD_MAINTENANCE:
                return addMaintenanceReducer(maintenances, action.payload);
            case UPDATE_MAINTENANCE:
                return updateMaintenanceReducer(maintenances, action.payload);
            case DELETE_MAINTENANCE:
                return deleteMaintenanceReducer(maintenances, action.payload);
            
            case LOG_OUT_USER:
                return {};
            default:
                return maintenances;
        }
    }else{
        return maintenances
    }
}

export default maintenancesReducer;